export default "__VITE_ASSET__CQj$htkl__"